// ITAM-2677 / ITAM-2734: the favourite-volunteer profile contract (verified
// against apoteka-back branch favourite-delivery-user: VolunteerProfileController,
// VolunteerProfileRequest/Response, VolunteerWorkingHoursRequest/Response).

import {
  DayOfWeek,
  DAYS_OF_WEEK,
  DAY_OF_WEEK_LABELS,
  WorkingHoursEntry,
} from "./shared";

// ITAM-2887: the day vocabulary is shared with the advisor schedule.
export type VolunteerDayOfWeek = DayOfWeek;

export type VolunteerWorkingHoursEntry = WorkingHoursEntry;

export interface VolunteerProfileRequest {
  /** Update lookup; the backend falls back to userId when absent. */
  id?: number;
  /** ALWAYS the logged-in user's own id, never from a route or form field. */
  userId: number;
  /** Update overwrites unconditionally; always send all three text fields. */
  firstName: string;
  secondName: string;
  biography: string;
  /** OMIT to leave the schedule alone; [] clears it. */
  workingHours?: VolunteerWorkingHoursEntry[];
}

export interface VolunteerProfileResponse {
  id: number;
  userId: number;
  firstName: string | null;
  secondName: string | null;
  biography: string | null;
  /** From the account's user_photo; not editable on this page. */
  userPhoto: string | null;
  workingHours: VolunteerWorkingHoursEntry[];
  /** true = on a break, regardless of schedule. */
  paused: boolean;
  /** Computed on read; refetch after saving hours or toggling pause. */
  available: boolean;
}

export const VOLUNTEER_DAYS: VolunteerDayOfWeek[] = DAYS_OF_WEEK;

export const VOLUNTEER_DAY_LABELS: Record<VolunteerDayOfWeek, string> =
  DAY_OF_WEEK_LABELS;
